import { CellProps } from 'react-table';
import { QuestionSubType } from '../constants';

export const npsColumns = [
  {
    Header: 'Total Responses',
    accessor: 'totalRes'
  },
  {
    Header: 'Average Rating',
    accessor: 'averageRating',
    Cell: (
      cell: CellProps<{
        id: string;
        question: string;
        totalRes: number;
        averageRating: number;
        totalPromoter: number;
        totalDetractor: number;
        npsScore: number;
      }>
    ) => {
      const { value } = cell;

      return value.toFixed(2);
    }
  },
  {
    Header: 'Total Promoter',
    accessor: 'totalPromoter'
  },
  {
    Header: 'Total Detractor',
    accessor: 'totalDetractor'
  },
  {
    Header: 'NPS Score',
    accessor: 'npsScore',
    Cell: (
      cell: CellProps<{
        id: string;
        question: string;
        totalRes: number;
        averageRating: number;
        totalPromoter: number;
        totalDetractor: number;
        npsScore: number;
      }>
    ) => {
      const { value } = cell;

      return value.toFixed(2);
    }
  }
];

export const QuestionTypeColorCodes = {
  [QuestionSubType.CONNECTION]: '#B5B5B5',
  [QuestionSubType.INFLUENCE]: '#A7DE72',
  [QuestionSubType.MEMBERSHIP]: '#25BCD3',
  [QuestionSubType.NEEDS]: '#DC5B58'
};
